<div class="backdrop" (click)="onClose()"></div>
<div class="slide-panel my-widgets-slider-panel">
  <div class="slider-header">
    <div class="title-wrapper">
      <div class="title-line">
        <h3 class="slider-title">My Widgets</h3>
        @if (widgets().length > 0) {
          <span class="widget-count">{{ widgets().length }}</span>
        }
      </div>
      @if (selectedWidgetsCount() > 0) {
        <div class="sub-line">
          <span class="selected-count">{{ selectedWidgetsCount() }} selected</span>
        </div>
      }
    </div>
    <div class="slider-header-actions">
      <button type="button" class="btn-reset" (click)="onReset()" [disabled]="applying() || loading()" aria-label="Reset widgets">
        <i class="fas fa-redo-alt"></i>
        Reset Widgets
      </button>
      <button type="button" class="close-btn" (click)="onClose()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>

  <div class="slider-body">
    @if (loading()) {
      <div class="loading-container">
        <app-spinner [size]="30"></app-spinner>
        <span class="loading-text">Loading widgets...</span>
      </div>
    } @else if (widgets().length === 0) {
      <div class="no-widgets-container">
        <i class="fas fa-th-large no-widgets-icon"></i>
        <h4 class="no-widgets-title">No Widgets Available</h4>
        <p class="no-widgets-message">There are no widgets assigned to your account. Please contact your administrator to get widgets added to your dashboard.</p>
      </div>
    } @else {
      <div class="widgets-grid">
        @for (item of widgets(); track item.id) {
          <div class="widget-card" (click)="onToggleWidget(item)" [class.selected]="item.checked">
            <div class="card-header">
              <span class="card-icon" [class.has-icon]="getWidgetIcon(item)">
                @if (getWidgetIcon(item); as icon) {
                  @if (isMatIcon(icon)) {
                    <mat-icon>{{ icon }}</mat-icon>
                  } @else {
                    <i [class]="icon"></i>
                  }
                } @else {
                  <i class="fas fa-th-large"></i>
                }
              </span>
              <span class="card-indicator" [class.selected]="item.checked" (click)="onToggleWidget(item); $event.stopPropagation()">
                @if (item.checked) {
                  <i class="fas fa-check"></i>
                }
              </span>
            </div>
            <span class="card-label">{{ item.label ?? item.name }}</span>
          </div>
        }
      </div>
    }
  </div>

  <div class="slider-footer">
    <div class="footer-right">
      <button type="button" class="btn btn-save" (click)="onApply()" [disabled]="applying()">
        @if (applying()) {
          <app-spinner [size]="18"></app-spinner>
        } @else {
          Apply
        }
      </button>
      <button type="button" class="btn btn-cancel" (click)="onCancel()" [disabled]="applying()">
        Cancel
      </button>
    </div>
  </div>
</div>
